import axios from 'axios';

const API = process.env.REACT_APP_API_URL;

// Fetch the company logo as a base64 data URL (auth-aware) for inlining into
// generated HTML / Word / PDF exports, where a remote, token-gated <img src>
// cannot load. The /api/company/logo/download endpoint needs the Authorization
// header (it routes to the tenant DB), so we fetch the blob with it and read it
// with FileReader. Returns '' on any failure so exports still succeed sans logo.
//
// For on-screen React <img>/<Avatar>, use the useCompanyLogo hook instead.
export async function loadLogoDataUrl(company) {
  try {
    let blob;
    if (company?.logoData || company?.logoFileName) {
      const res = await axios.get(`${API}/api/company/logo/download`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      });
      blob = res.data;
    } else if (company?.logoUrl) {
      const res = await axios.get(company.logoUrl, { responseType: 'blob' });
      blob = res.data;
    } else {
      return '';
    }
    return await new Promise((resolve) => {
      const fr = new FileReader();
      fr.onload = () => resolve(fr.result || '');
      fr.onerror = () => resolve('');
      fr.readAsDataURL(blob);
    });
  } catch {
    return '';
  }
}
